/**
 * Debounce
 *
 * A custom debounce implementation used to avoid depending on lodash/underscore
 *
 * @author    Frontend Design Systems <FrontendDesignSystems@wayfair.com>
 * @copyright 2019 Wayfair LLC - All rights reserved
 */

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// `wait` milliseconds.
// Taken from https://gist.github.com/peduarte/7ee475dd0fae1940f857582ecbb9dc5f
export default function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}
